(function () {
  "use strict";

  angular
    .module("admin.post.logs.service", [])
    .factory("PostLogsService", PostLogsService);

  /** @ngInject */
  function PostLogsService($http, $q, API) {
    function list(parentId, start, limit) {
      var defered = $q.defer();

      $http
        .get(
          API.API_URL +
            "admin/posts/" +
            parentId +
            "/post_logs?start=" +
            start +
            "&limit=" +
            limit
        )
        .success(defered.resolve);

      return defered.promise;
    }

    return {
      list: list,
    };
  }
})();
